<template>
    <Modal :close_button="true" :size="'modal-md'" mid="manage-store-member">
        <template v-slot:header>
            <span v-if="member && member.id">{{$t('management_console.member_modal.edit_title')}}</span>
            <span v-else>{{$t('management_console.member_modal.create_title')}}</span>
        </template>
        <template v-slot:body>
            <div class="row mb-3">
                <div class="col">
                    <label class="form-label fw-bold">{{$t('management_console.common.username')}}<span class="ms-1 text-red-500">*</span></label>
                    <input v-model="form.username" type="text" class="form-control form-control-lg" :placeholder="$t('management_console.member_modal.username_placeholder')" :aria-label="$t('management_console.common.username')">
                    <small class="d-block mt-1 mb-2">{{$t('management_console.member_modal.username_help')}}</small>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col">
                    <label class="form-label fw-bold">{{$t('management_console.common.role')}}<span class="ms-1 text-red-500">*</span></label>
                    <div class="dropdown">
                        <button type="button" class="btn btn-outline-secondary w-100 dropdown-toggle fw-bold" data-bs-toggle="dropdown" aria-expanded="false">
                            {{$t(`management_console.member_modal.role_${form.role}`)}}
                        </button>
                        <ul class="dropdown-menu dropdown-menu-start">
                            <li @click="form.role = 'sales'" class="p-2 pe-pointer">{{$t('management_console.member_modal.role_sales')}}</li>
                            <li @click="form.role = 'delivery'" class="p-2 pe-pointer">{{$t('management_console.member_modal.role_delivery')}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col">
                    <label class="form-label fw-bold">{{$t('management_console.member_modal.workplace_access')}}</label>
                    <div v-for="(name, id) in locations" :key="id" class="form-check">
                        <input v-model="form.restricted_locations" class="form-check-input" type="checkbox" :value="id" :id="'restrict-l-'+id">
                        <label class="form-check-label" :for="'restrict-l-'+id">
                            {{name}}
                        </label>
                    </div>
                    <small class="d-block mt-1 mb-2" v-html="$t('management_console.member_modal.workplace_help')"></small>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <small><span class="text-red-500">*</span> {{$t('console.fields_are_mandatory')}}</small>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button :disabled="!valid_form && !loading" type="button" class="btn btn-success bg-gradient px-4" @click="submit()">
                <span v-if="member && member.id">{{$t('controls.update')}}</span>
                <span v-else>{{$t('controls.create')}}</span>
            </button>
            <button type="button" class="btn px-4" @click="cancel()">{{$t('controls.cancel')}}</button>
        </template>
    </Modal>
</template>

<script>
import InventoryMemberStore from '@/common/store/inventory_member.js'
import InventoryLocationStore from '@/common/store/inventory_location.js'

export default {
    props: {
        member: {
            type: Object,
            default: () => {}
        }
    },
    data: function () {
        return {
            loading: false,
            locations: {},
            form: {
                username: '',
                role: 'sales',
                restricted_locations: []
            }
        }
    },
    computed: {
        valid_form: function () {
            return this.form.username.length >= 4 &&
                this.form.username.length < 255
        }
    },
    watch: {
        member: function () {
            if (this.member && this.member.id) {
                this.form.username = this.member.username
                this.form.role = this.member.role
                this.form.restricted_locations = Object.keys(this.member.locations)
            } else {
                this.form.username = ''
                this.form.role = 'sales'
                this.form.restricted_locations = []
            }
        }
    },
    created: async function () {
        const self = this
        this.$bus.$off('Modal/shown/manage-store-member')
        this.$bus.$on('Modal/shown/manage-store-member', async function () {
            await self.get_locations()
        })
    },
    methods: {
        add_restricted_location: function (id) {
            this.form.restricted_locations.push(id)
        },
        get_locations: async function () {
            const response = await InventoryLocationStore.dispatch('GET_ASSOC')
            if (response.data.status === 0) {
                this.locations = response.data.items
            } else {
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.something_went_wrong'), msg: this.$t('notifications.please_retry_the_operation_or_refresh'), level: 'danger' })
            }
        },
        cancel: async function () {
            this.$bus.$emit('Modal/hide/manage-store-member')
        },
        submit: async function () {
            this.loading = true

            const payload = {
                username: this.form.username,
                role: this.form.role,
                restricted_locations: this.form.restricted_locations
            }

            let response = null
            if (this.member && this.member.id) {
                response = await InventoryMemberStore.dispatch('UPDATE', {
                    id: this.member.id,
                    params: payload
                })
            } else {
                response = await InventoryMemberStore.dispatch('CREATE', payload)
            }

            if (response.status === 200) {
                this.$bus.$emit('Modal/hide/manage-store-member')
                this.form.username = ''
                this.form.role = 'sales'
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.operation_success'), msg: this.$t('notifications.operation_success_description'), level: 'success' })
            } else if (response.status === 409) {
                this.$bus.$emit('Notification/show', { title: this.$t('management_console.member_modal.limit_title'), msg: this.$t('management_console.member_modal.limit_description'), level: 'danger' })
            } else if (response.status === 422) {
                this.$bus.$emit('Notification/show', { title: this.$t('management_console.member_modal.exists_title'), msg: this.$t('management_console.member_modal.exists_description'), level: 'danger' })
            } else {
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.something_went_wrong'), msg: this.$t('notifications.please_retry_the_operation_or_refresh'), level: 'danger' })
            }

            this.loading = false
        }
    }
}
</script>
